import { CompanyBranchCreatePage } from "@/features/company/pages/CompanyBranchCreate";

const CompanyBranchCreate = () => {
  return <CompanyBranchCreatePage />;
};

export default CompanyBranchCreate;
